import Fetcher from '../../../../../services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from '../../../../../constants'
import {
  AddContractCategoryRequestData,
  AddContractCategoryResponse
} from './types'

const fetcher = new Fetcher({})

export const getCCTableData = async (data) =>
  fetcher.request<AddContractCategoryRequestData, AddContractCategoryResponse>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.ORG_CONTRACT_CATEGORIES}`,
    method: HTTP_METHODS.GET,
    ...data
  })
